@if (!loading) {
  @if (showCaptainsWidget) {
    <div id="widget-multi-container">
      <widget-top-captains [data]="data" (clicked)="clicked = true;"></widget-top-captains>
    </div>
  }
}